"use strict";

require("core-js/modules/es.array.iterator");

var go = require("./go.js");

var entries = require("./entries.js");

var object = require("./object.js");

var curry = require("./curry.js");

var identity = require("./identity.js");

var map = require("./map.js");

module.exports = curry(function evolve(dict, obj) {
  return go(obj, entries, map(([k, v]) => go(v, v => typeof v === 'object' ? evolve(dict[k] || {}, v) : (dict[k] || identity)(v), v => [k, v])), object);
});